export const isVisibleContainer = (
  id: string,
  expandable: boolean,
  expanded: boolean,
  expandedContainers: Record<string, boolean>,
): boolean => !expandable || (expandedContainers?.[id] !== undefined ? expandedContainers[id] : expanded) || false;
